import { PageSlice as PageSliceIcon } from "@shared/assets/icons";

export type PageSliceProps = {
  className?: string;
};

export function PageSlice({ className }: PageSliceProps) {
  return (
    <PageSliceIcon
      className={[
        "hidden xl:block absolute w-screen h-12 lg:h-20",
        className,
      ].join(" ")}
    />
  );
}
